module.exports = __webpack_public_path__ + "static/img/rizi1.8574da6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/rizi1.jpg
// module id = MJkP
// module chunks = 5